import { OPEN_AUTHOR, OPEN_REFERENCE } from './types';
import getPdfViewerApplication from '../../client/utils/pdfjs/pdfViewerApplication';
import { openPanel } from './sidebar';
import { panelGroup, panelType, referenceType as referenceTypeConstant } from '../constants';
import { isPanelOpen } from './sidebarUtils';

const enhancementManager = () => getPdfViewerApplication().enhancementManager;

const openPanelHandlerWithCustomAction = ({
  type, createPayload, panel, setActive,
}) => async (dispatch, data, event) => {
  event.stopPropagation();
  dispatch({
    type,
    payload: createPayload(data),
  });
  await setActive(data);
  dispatch(openPanel(panelGroup.enhancements, panel));
};

export const authorClickHandler = openPanelHandlerWithCustomAction({
  type: OPEN_AUTHOR,
  createPayload: ({ index }) => index - 1,
  panel: panelType.author,
  setActive: ({ index }) => enhancementManager().setActiveAuthor(index - 1),
});

const bibliographyClickHandler = openPanelHandlerWithCustomAction({
  type: OPEN_REFERENCE,
  createPayload: ({ instanceIndex }) => ({ instanceIndex }),
  panel: panelType.reference,
  setActive: ({ referenceType, instanceIndex }) => enhancementManager().setActiveReference(
    referenceType,
    instanceIndex,
  ),
});

const figureClickHandler = (data, event) => async (dispatch, getState) => {
  event.stopPropagation();

  const { referenceType, instanceIndex } = data;
  await enhancementManager().setActiveReference(referenceType, instanceIndex);

  const index = isPanelOpen(getState(), panelGroup.enhancements, panelType.figures) ? 1 : 0;
  dispatch(openPanel(panelGroup.enhancements, panelType.figure, { index }));
};

export function referenceClickHandler(dispatch, data, event) {
  if (data.referenceType === referenceTypeConstant.figure) {
    dispatch(figureClickHandler(data, event));
  } else if (data.referenceType === referenceTypeConstant.bibliography) {
    bibliographyClickHandler(dispatch, data, event);
  }
}
